var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1229 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15-blue",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    transform: "translate(899.000000, 220.000000) rotate(90.000000) translate(-899.000000, -220.000000) translate(694.000000, -66.585366)",
    fill: "#F8F9F9",
    stroke: "#305B86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8903896,23.7498498 C94.2251669,30.6340577 157.098282,28.7299267 218.509734,18.0374544 C310.626913,1.99874712 410,-17.9378806 410,30.4290285 C410,78.7959375 410,110.645368 410,145.586834 C410,180.528302 410,383.906535 410,416.568896 C410,449.231256 410,507.094443 410,532.904967 C410,558.715491 399.709468,558.715491 373.563358,558.715491 C347.417248,558.715491 54.076917,591.239783 19.6472292,558.715491 C-14.7824566,526.191197 6.51036326,218.03981 6.51036326,188.948535 C6.51036326,159.857259 6.51036326,128.281442 6.51036326,106.346852",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock0001_DL",
    stroke: "#305B86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock0001_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9229829,35.0215396 C139.11095,-27.3090085 251.244608,120.714046 146.962812,180.045164 C47.0094228,236.909551 -12.8797061,129.57796 36.5981135,49.5243819",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.906977,25.6029268 C183.396382,-0.53926081 211.824838,59.1195794 192.407645,63",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9069767,21.2031701 C24.5962159,-2.84689927 -10.0164166,49.9581806 4.29885359,62",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.906977,0.22111111 C106.857848,1.47611111 92.9228246,0.22111111 78.9069767,0.22111111",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9069767,53 C104.765158,148.124456 85.4959388,123.619767 131.906977,97.2839305",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9069767,70 C99.9539006,49.0327826 98.640032,49.2924233 108.906977,67.1537492",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.906977,94.5248956 C136.929532,89.8246061 135.969345,91.1651421 132.740961,103",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9069767,177 C26.3600883,183.168478 21.7188494,193.195652 16.9069767,201",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906977,177 C168.870908,184.178872 173.427493,191.871549 176.906977,201",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "boyarmsfolded_DL",
    transform: "translate(226.000000, 20.000000)",
    stroke: "#305B86",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8254822,19.8325102 C66.9364636,2.47865388 103.389656,-6.1371405 131.121753,4.97291411 C220.655044,40.8380942 171.692555,161.5285 81.9657366,149.54627 C21.4862953,141.472529 24.8174409,30.5676108 71.8487713,11.7261645",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3897448,421.896988 C61.5996093,421.896988 67.5828115,417.818871 67.5828115,414.824377 C67.5828115,411.829884 73.5225194,360.911659 74.3860744,347.987884 C75.0757968,337.618063 74.704133,305.446044 74.704133,301.772046 C74.704133,298.09805 76.3094035,296.873383 72.2062904,294.386911 C68.1031772,291.900442 11.0678251,268.190385 2.64372233,256.262698 C-3.92236887,246.96577 3.2063863,243.874296 8.19225986,239.402263 C13.1781334,234.930231 23.8678791,225.165741 32.2230537,218.166968 C38.6212109,212.810938 58.864515,193.166784 61.3318149,188.653517 C63.5972447,184.495322 79.5225441,184.824726 84.2496665,184.174473 C96.799251,182.459004 120.402143,177.13741 132.934905,180.987591 C140.471385,183.297698 192.276738,217.26207 196.807597,223.730374 C200.598268,229.146295 200.502939,226.669346 195.383292,235.178246 C190.616918,243.08823 183.240832,252.587217 175.917438,260.334637 C166.721138,270.067039 148.168765,283.392643 139.808774,292.418961 C133.371364,299.369461 131.09472,344.336526 131.773227,354.644347 C132.382195,363.89574 132.653604,400.367431 132.911549,405.419725 C133.421832,415.413084 129.309374,416.025002 138.174831,420.859117 C141.982324,422.933938 152.532706,418.424948 152.925231,420.859117",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0566638,284.049457 C67.8124335,256.613082 65.6903184,238.813415 65.6903184,230.650454 C65.6903184,222.487495 64.3314353,208.261978 61.613669,187.973906",
    id: "Path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.758932,284.049457 C138.54373,264.175376 139.93613,249.917581 139.93613,241.276073 C139.93613,232.634565 139.93613,214.867176 139.93613,187.973906",
    id: "Path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(689.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.894182,197.128663 C170.356851,196.920426 160.473787,197.026686 154.032234,189.875101 C127.436582,160.347896 155.978421,104.627116 203.314177,127.504883 C230.952589,140.862759 208.179903,200.90815 179.782336,190.600457",
    id: "Path",
    stroke: "#305B86",
    strokeWidth: 18,
    fillOpacity: 0.453043051,
    fill: "#305B86",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.580837,29.6481582 C135.828551,29.615287 133.570654,26.5109084 130.65159,23.0455976 C129.210845,21.3352451 127.331274,18.8468648 125.85961,17.1877197 C123.947137,15.0316095 122.09384,13.3023696 120.299717,12 C119.653466,12 114.045634,18.3322953 113.626228,18.8046071 C112.436327,20.144606 107.482944,26.4130678 106.826642,27.190082 C106.243395,27.8803731 105.678312,28.5775626 105.106599,29.2722436 C105.067884,29.3191888 105.041367,29.370703 105,29.4341327",
    id: "Path",
    stroke: "#305B86",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(120.299717, 20.824079) rotate(270.000000) translate(-120.299717, -20.824079) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.580837,29.6481582 C302.828551,29.615287 300.570654,26.5109084 297.65159,23.0455976 C296.210845,21.3352451 294.331274,18.8468648 292.85961,17.1877197 C290.947137,15.0316095 289.09384,13.3023696 287.299717,12 C286.653466,12 281.045634,18.3322953 280.626228,18.8046071 C279.436327,20.144606 274.482944,26.4130678 273.826642,27.190082 C273.243395,27.8803731 272.678312,28.5775626 272.106599,29.2722436 C272.067884,29.3191888 272.041367,29.370703 272,29.4341327",
    id: "Path",
    stroke: "#305B86",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(287.299717, 20.824079) rotate(90.000000) translate(-287.299717, -20.824079) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,70.0095561 C390.609338,70.0095561 255.786674,54.67322 407,73",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,132.009556 C392.609338,132.009556 257.786674,116.67322 409,135",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44,199.338642 C195.932026,199.338642 113.117121,190.818456 206,201",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8,
    transform: "translate(81.000000, 198.500000) rotate(90.000000) translate(-81.000000, -198.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,203.338642 C262.932026,203.338642 180.117121,194.818456 273,205",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8,
    transform: "translate(148.000000, 202.500000) rotate(90.000000) translate(-148.000000, -202.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,198.338642 C325.932026,198.338642 243.117121,189.818456 336,200",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8,
    transform: "translate(211.000000, 197.500000) rotate(90.000000) translate(-211.000000, -197.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,199.338642 C388.932026,199.338642 306.117121,190.818456 399,201",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8,
    transform: "translate(274.000000, 198.500000) rotate(90.000000) translate(-274.000000, -198.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,198.338642 C451.932026,198.338642 369.117121,189.818456 462,200",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8,
    transform: "translate(337.000000, 197.500000) rotate(90.000000) translate(-337.000000, -197.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,192.009556 C395.609338,192.009556 260.786674,176.67322 412,195",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,252.009556 C395.609338,252.009556 260.786674,236.67322 412,255",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,324.009556 C390.609338,324.009556 255.786674,308.67322 407,327",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5,201.506371 C533.586316,201.506371 443.81496,191.282147 544.5,203.5",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 16,
    transform: "translate(409.000000, 200.500000) rotate(90.000000) translate(-409.000000, -200.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125,199.006371 C132.207131,199.006371 43.4295542,188.782147 143,201",
    id: "Path-11",
    stroke: "#305B86",
    strokeWidth: 16,
    transform: "translate(9.000000, 198.000000) rotate(90.000000) translate(-9.000000, -198.000000) "
  }), /*#__PURE__*/React.createElement("text", {
    id: "JUNE",
    fontFamily: "BradleyHandITCTT-Bold, Bradley Hand",
    fontSize: 25,
    fontStyle: "expanded",
    fontWeight: "bold",
    letterSpacing: -0.25,
    fill: "#305B86"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 174,
    y: 21
  }, "JUNE")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.94bca8a022c48e2f935c6a114586131f.svg";
export { ForwardRef as ReactComponent };